import { Badge, Dropdown, Form } from "react-bootstrap";

import {
  canApproveRegistration,
  canUnapproveRegistration,
  formatRegistrationDate,
  getCategoryTitle,
  getDriverName,
  getInheritedConsentInfo,
  getStatusBadgeVariant,
  getTeamName,
  getTeamNumber,
} from "../utils/competitors.utils";

const CompetitorsTable = ({
  registrations = [],
  categories = [],
  canManage = false,
  selectedIds = [],
  approvingId = "",
  uploadingCategoryId = "",
  onToggleSelect,
  onToggleSelectAll,
  onApprove,
  onUnapprove,
  onView,
  onDownloadConsent,
  onDownloadSignedConsent,
  onUploadSignedConsent,
}) => {
  const allIds = registrations
    .map((item) => item._id || item.id)
    .filter(Boolean);
  const allSelected =
    allIds.length > 0 && allIds.every((id) => selectedIds.includes(id));
  const someSelected = selectedIds.length > 0 && !allSelected;

  return (
    <div className="table-responsive">
      <table className="table table-striped mb-0">
        <thead>
          <tr>
            <th style={{ width: 40 }}>
              <Form.Check
                type="checkbox"
                checked={allSelected}
                ref={(el) => {
                  if (el) el.indeterminate = someSelected;
                }}
                onChange={(e) => onToggleSelectAll(e.target.checked)}
                aria-label="Select all registrations"
              />
            </th>
            <th style={{ width: 48 }}>#</th>
            <th style={{ minWidth: 140 }}>Driver</th>
            <th style={{ minWidth: 140 }}>Team</th>
            <th style={{ width: 90 }}>No.</th>
            <th style={{ minWidth: 120 }}>Category</th>
            <th style={{ width: 110 }}>Status</th>
            <th style={{ width: 110 }}>Consent</th>
            <th style={{ minWidth: 150 }}>Registered</th>
            <th className="text-center" style={{ width: 88 }}>
              Actions
            </th>
          </tr>
        </thead>
        <tbody>
          {registrations.map((registration, index) => {
            const id = registration._id || registration.id;
            const status = registration.status || "";
            const consent = getInheritedConsentInfo(registration, categories);
            const busy = Boolean(approvingId) && approvingId === id;
            const uploading =
              Boolean(uploadingCategoryId) &&
              uploadingCategoryId === consent.categoryId;
            const selected = Boolean(id) && selectedIds.includes(id);

            return (
              <tr key={id || `registration-${index}`}>
                <td>
                  <Form.Check
                    type="checkbox"
                    checked={selected}
                    disabled={!id}
                    onChange={() => onToggleSelect(id)}
                    aria-label={`Select ${getDriverName(registration)}`}
                  />
                </td>
                <td>{index + 1}</td>
                <td>{getDriverName(registration)}</td>
                <td>{getTeamName(registration)}</td>
                <td>{getTeamNumber(registration)}</td>
                <td>{getCategoryTitle(registration)}</td>
                <td>
                  <Badge bg={getStatusBadgeVariant(status)}>
                    {status || "-"}
                  </Badge>
                </td>
                <td>
                  <Badge bg={consent.isSigned ? "success" : "secondary"}>
                    {consent.isSigned ? "Signed" : "Not signed"}
                  </Badge>
                </td>
                <td>
                  {formatRegistrationDate(
                    registration.registered_at || registration.createdAt
                  )}
                </td>
                <td className="text-center align-middle">
                  <Dropdown>
                    <Dropdown.Toggle
                      variant="link"
                      className="p-0 text-decoration-none"
                    >
                      &#x2022;&#x2022;&#x2022;
                    </Dropdown.Toggle>
                    <Dropdown.Menu align="end">
                      <Dropdown.Item
                        onClick={() => onView(registration)}
                        disabled={!id}
                      >
                        View
                      </Dropdown.Item>
                      {consent.hasConsentTemplate ? (
                        <Dropdown.Item
                          onClick={() => onDownloadConsent(registration)}
                        >
                          Download consent
                        </Dropdown.Item>
                      ) : null}
                      {consent.signedUrl ? (
                        <Dropdown.Item
                          onClick={() =>
                            onDownloadSignedConsent(consent.signedUrl)
                          }
                        >
                          Download signed consent
                        </Dropdown.Item>
                      ) : null}
                      {canManage && consent.categoryId ? (
                        <Dropdown.Item
                          onClick={() => onUploadSignedConsent(registration)}
                          disabled={uploading}
                        >
                          {uploading
                            ? "Uploading..."
                            : consent.isSigned
                              ? "Replace signed consent"
                              : "Upload signed consent"}
                        </Dropdown.Item>
                      ) : null}
                      {canApproveRegistration(status) ? (
                        <Dropdown.Item
                          onClick={() => onApprove(registration)}
                          disabled={!canManage || !id || busy}
                        >
                          {busy ? "Approving..." : "Approve"}
                        </Dropdown.Item>
                      ) : null}
                      {canUnapproveRegistration(status) ? (
                        <Dropdown.Item
                          onClick={() => onUnapprove(registration)}
                          disabled={!canManage || !id || busy}
                        >
                          {busy ? "Updating..." : "Set pending"}
                        </Dropdown.Item>
                      ) : null}
                    </Dropdown.Menu>
                  </Dropdown>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default CompetitorsTable;
